import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  orderData: {},
  pageFlag: 'create'
}

export const userSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    // 自动生成 action creator 和 reducer
    setOrderDataAction: (state, action) => {
      state.orderData = action.payload
    },
    setOrderPageFlagAction: (state, action) => {
      state.pageFlag = action.payload
    },
  }
})

// 自动生成的 action creators
export const { setOrderDataAction, setOrderPageFlagAction } = userSlice.actions

// Selectors
export const selectOrderData = (state) => state.order.orderData
export const selectOrderPageFlag = (state) => state.order.pageFlag

// Reducer
export default userSlice.reducer